import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const kitItems = [{
  title: 'Ebook Maestro (60 págs)',
  subtitle: 'El Código Invisible del Dinero',
  description: 'El manual central donde descubrirás cómo reprogramar tus creencias limitantes y sintonizar con la frecuencia de la abundancia.',
  image: 'https://cdn.magicpatterns.com/uploads/iWimrgztMff35AKnRwAAP8/Ebook_inicial.png',
  isMain: true
}, {
  title: 'Bono 1: Guionismo de Realidades',
  subtitle: 'Escribe tu nueva vida',
  description: 'Una guía práctica para usar el poder de la palabra escrita y manifestar tus deseos financieros con precisión.',
  image: 'https://cdn.magicpatterns.com/uploads/tHaUo3Q2fteRSt3z8qZjaH/Bonos_1.png',
  isMain: false
}, {
  title: 'Bono 2: Mapa de los 5 Canales',
  subtitle: 'Diversificación de Ingresos',
  description: 'Descubre cómo crear múltiples fuentes de ingresos alineadas con tu propósito y energía femenina.',
  image: 'https://cdn.magicpatterns.com/uploads/qBT1S5rWH7vN2jdgswgyYM/Bonos_2.png',
  isMain: false
}, {
  title: 'Bono 3: Billetera Magnética',
  subtitle: 'Limpieza energética',
  description: 'Un checklist paso a paso para purificar tu relación física y energética con el dinero que entra y sale de tu vida.',
  image: 'https://cdn.magicpatterns.com/uploads/2o2rABF6mjBvDBGuDRLwtk/Bonos_3.png',
  isMain: false
}];
export function KitSection() {
  return <section className="py-24 bg-[#FAF5E9]" data-id="element-64">
      <div className="max-w-6xl mx-auto px-6" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-900 mb-4" data-id="element-67">
            Tu Kit de Transformación
          </h2>
          <p className="text-stone-600 text-lg max-w-2xl mx-auto" data-id="element-68">
            Todo lo que necesitas para iniciar tu viaje hacia la libertad
            financiera consciente, entregado de forma inmediata.
          </p>
        </div>

        <div className="space-y-16 md:space-y-24" data-id="element-69">
          {kitItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 md:gap-16`} data-id="element-70">
              <div className="w-full md:w-1/2" data-id="element-71">
                <div className={`relative rounded-2xl overflow-hidden shadow-2xl ${item.isMain ? 'ring-4 ring-[#C5A059]/20' : ''}`} data-id="element-72">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" data-id="element-73" />
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-4" data-id="element-74">
                {item.isMain && <span className="inline-block py-1 px-3 rounded-full bg-[#C5A059] text-white text-xs font-bold tracking-wider uppercase mb-2" data-id="element-75">
                    Material Principal
                  </span>}
                {!item.isMain && <span className="inline-block py-1 px-3 rounded-full bg-stone-200 text-stone-700 text-xs font-bold tracking-wider uppercase mb-2" data-id="element-76">
                    Regalo Exclusivo
                  </span>}
                <h3 className="text-3xl font-serif font-bold text-stone-900" data-id="element-77">
                  {item.title}
                </h3>
                <h4 className="text-xl text-[#A8823A] font-medium italic font-serif" data-id="element-78">
                  {item.subtitle}
                </h4>
                <p className="text-stone-600 text-lg leading-relaxed" data-id="element-79">
                  {item.description}
                </p>
                <ul className="space-y-2 pt-4" data-id="element-80">
                  <li className="flex items-start gap-2 text-stone-700" data-id="element-81">
                    <CheckCircle2 className="w-5 h-5 text-[#C5A059] shrink-0 mt-0.5" data-id="element-82" />
                    <span data-id="element-83">Acceso digital inmediato</span>
                  </li>
                  <li className="flex items-start gap-2 text-stone-700" data-id="element-84">
                    <CheckCircle2 className="w-5 h-5 text-[#C5A059] shrink-0 mt-0.5" data-id="element-85" />
                    <span data-id="element-86">Formato PDF optimizado</span>
                  </li>
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}